/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { GuaranteedRestoreTimeService } from './GuaranteedRestoreTimeService';

class GuaranteedRestoreTimeServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new GuaranteedRestoreTimeService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { GuaranteedRestoreTimeServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/GuaranteedRestoreTimeServiceProvider.js